import React, { useContext } from 'react';
import { Breadcrumbs } from '@thd-olt-component-react/breadcrumbs';
import { CustomerAccountNavigation, useAccountCrumbs, } from '@thd-olt-component-react/customer-account-navigation';
import { QueryProvider, extend } from '@thd-nucleus/data-sources';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { useInterceptors } from '../hooks/use-interceptors';
import { Alert } from '../components/shared/alert/alert';
import { PageTitle } from '../components/shared/page-title';
import { AddressesContent } from '../components/addresses/address-content/address-content';
import { mapCrumbsToStaticCrumbs, } from '../utils/breadcrumbs';
const crumbs = [
    {
        label: 'Addresses',
        path: '/myaccount/addresses',
    },
];
export const Addresses = () => {
    const { redirectError } = useInterceptors();
    const { isConsumerApp } = useContext(ExperienceContext);
    const staticCrumbs = mapCrumbsToStaticCrumbs(useAccountCrumbs(crumbs));
    return (React.createElement("div", { className: "grid isBound" },
        React.createElement("div", { className: "col__12-12" }, redirectError ? (React.createElement("div", { className: "sui-pt-8" },
            React.createElement(Alert, { status: "info" }, redirectError.message))) : (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "sui-grid sui-gap-3 sm:sui-py-4" },
                !isConsumerApp && (React.createElement(ErrorBoundary, { name: "breadcrumbs" },
                    React.createElement(QueryProvider, { cacheKey: "addresses-page" },
                        React.createElement(Breadcrumbs, { staticCrumbs: staticCrumbs })))),
                React.createElement(PageTitle, { title: "Addresses", dataTestId: "addresses-title" })),
            React.createElement("div", { className: "sui-grid sui-grid-cols-12 sui-gap-5 sui-pt-2" },
                React.createElement("div", { className: "sui-col-span-12 lg:sui-col-span-3" },
                    React.createElement(ErrorBoundary, { name: "customer-account-navigation" },
                        React.createElement(QueryProvider, { cacheKey: "left-nav" },
                            React.createElement(CustomerAccountNavigation, null)))),
                React.createElement("div", { className: "sui-col-span-12 lg:sui-col-span-9" },
                    React.createElement(ErrorBoundary, { name: "addresses-content" },
                        React.createElement(AddressesContent, null)))))))));
};
Addresses.displayName = 'Addresses';
Addresses.dataModel = extend(CustomerAccountNavigation, Breadcrumbs);
